export default __webpack_public_path__ + "static/media/instrument-titanium.4fc79377.jpeg";